import React from 'react'
import LxNav from '../../LxNav/Three'
import styles from './index.module.scss'
import LxOutLogin from '../../LxOutLogin'
import defaultSetting from '@/setting'
import { hasLoginApi, getNavApi } from '@/api'
import { navList }  from '../../../constants';
const defaultLogo = require('@/assets/images/logo_daohang.png')
const logo = require('@/assets/images/logo.png')
const deepColor = 'rgba(34, 34, 34, 0.65)'
const lightColor = '#fff'

class Header extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            isToggle: false,
            userInfo: {},
            navAll: []
        }
    }
    componentDidMount() {
        getNavApi().then(res => {
            this.setState({
                navAll: [...navList, ...res.data]
            })
        })
        hasLoginApi().then(res => {
            this.setState({
                userInfo: res.data
            })
        })
        window.addEventListener('scroll', this.handleScroll);
    }
    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }
    handleScroll = () => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        if (scrollTop < 50 || scrollTop === 50 ) {
            this.setState({
                isToggle: false
            })
        } else {
            this.setState({
                isToggle: true
            })
        }
    }
    render() {
        return (
            <div className={`header ${styles.header}`}>
                <header className={`lx-w100 lx-bg-color-white lx-flex-row ${this.state.isToggle? 'active':''}`}>
                    <div className="lx-flex-shrink-0 logo-wrap lx-hidden lx-fz0">
                        <img className="lx-h100" src={!this.state.isToggle?defaultLogo:logo} alt="logo" />
                    </div>
                    <div className="lx-flex-grow-1 header-middle">
                        <LxNav isToggle={this.state.isToggle} navList={this.state.navAll}></LxNav>
                    </div>
                    <div className="lx-flex-shrink-0 header-right">
                        {
                            this.state.userInfo.userName?(
                                <LxOutLogin {...this.state.userInfo} titleColor={`${this.state.isToggle?deepColor:lightColor}`}></LxOutLogin>
                            ):(
                                <div className="handle-wrap lx-flex-row">
                                    {/* <a href={`/${defaultSetting.suiteKey}/pb/logAndReg.html?modalType=0`} className="handle-btn-register lx-fz14">注册</a> */}
                                    <a href={`/${defaultSetting.suiteKey}/pb/logAndReg.html?modalType=0`} className="handle-btn-login lx-fz14 lx-ml20">注册/登录</a>
                                </div>
                            )
                        }
                    </div>
                </header>
            </div>
        )
    }
}
  
export default Header;